module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.optionsReady && _vm.showNewsletterButton) ? _c('div', {
    staticClass: "newsletter-button",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "newsletter-modal-wrapper"
  }, [_c('div', {
    staticClass: "newsletter-button-container"
  }, [_c('a', {
    domProps: {
      "textContent": _vm._s(_vm.openButtonText)
    },
    on: {
      "click": function($event) {
        return _vm.openModal()
      }
    }
  })])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f2993e6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NewsletterButton.vue
// module id = 338
// module chunks = 0